<template>
  <div>
    <!-- 轮播图 -->
    <v-carousel
      cycle
      hide-delimiters
      :show-arrows="false"
      :height="wrapHeight - 99"
      v-model="slidesValue"
      style="position:relative; cursor: pointer"
    >
      <v-carousel-item v-for="slide in slides" :key="slide.id">
        <v-img
          :src="slide.image"
          :lazy-src="slide.image"
          :height="wrapHeight - 99"
          style="position: relative"
          @click="onclickSlideItem(slide)"
        >
          <div class="banner-content">
            <!-- 渲染图片的介绍信息 -->
            <div class="banner-description white--text">
              <template v-for="descItem in slide.desc">
                <!-- 按行渲染 -->
                <div :key="descItem.row">
                  <!-- 按行的内容渲染 -->
                  <template v-for="rowItem in descItem.content">
                    <span :key="rowItem.text">
                      <template v-if="!rowItem.strong">{{ rowItem.text }}</template>
                      <strong v-else>{{ rowItem.text }}</strong>
                    </span>
                  </template>
                </div>
              </template>
              <div class="white my-8 banner-hr"/>
              <div style="font-size: 18px" class="pt-6">{{ slide.descSub }}</div>
            </div>
          </div>
        </v-img>
      </v-carousel-item>
<!--      <div id="position-dss" class="banner-toggle-btn d-flex align-center">-->
<!--        <template v-for="btn in slides.length">-->
<!--          <div-->
<!--            :key="btn"-->
<!--            class="mx-1 transition-ease-in-out"-->
<!--            :style="{ backgroundColor: slidesValue === (btn - 1) ? '#134D91' : 'rgba(36,52,75,0.3)' }"-->
<!--            style="width: 18px; height: 18px; border-radius: 50%"-->
<!--            @click.stop="onclickSlideButton(btn)"-->
<!--          />-->
<!--        </template>-->
<!--      </div>-->
    </v-carousel>
    <div style="width: 100%; padding: 0 0 100px 0; position: relative; top: -10px">
      <!-- 智能临床科研平台 -->
      <dss-card title="智能临床科研平台" :wrap-width="wrapWidth">
        <div class="py-9" style="font-size: 16px; color: #666">
          <div></div>
          <div></div>
          知识视觉成立于2016年，致力于用人工智能赋能临床科研，已累计服务过百家医疗相关企业、机构。智能临床科研平台以医生做科研时“文献和数据的采集、处理、分析和转化工作量巨大且难度高，创新性不足，缺乏可重复性等问题”为切入点，基于全过程的人工智能（AI）辅助，提供科研全流程的智能化一体化解决方案，包括：文献的自动检索与筛选、文献的自动阅读理解与关键信息提取、国内外研究现状自动分析、发展趋势洞察、推荐创新点、移植研究方法和实验设计、自动构建分析模型、回顾性验证、前瞻性研究、智能化数据统计与分析、成果转化模块等。
        </div>
      </dss-card>
      <!-- 人工智能赋能临床科研的数智化转型 -->
      <dss-card title="人工智能赋能临床科研的数智化转型" :wrap-width="wrapWidth" style="padding-top: 132px;background: #FCFBFC">
        <decision-making/>
      </dss-card>
    </div>
    <!-- 提供基于人工智能的临床科研一体化解决方案 -->
    <dss-card class="index-model-3" :wrap-width="wrapWidth" title="提供基于人工智能的临床科研一体化解决方案">
<!--      <div class="py-9" style="font-size: 16px; color: #666">-->
<!--        <div>-->
<!--          知识视觉打造了一套无代码化的智能决策引擎平台，能够实现从数据管理到数字化和智能化全流程无代码化研发。专家只需要通过勾选、拖拽就可以完成整个应用的开发，不需要编写任何一行代码，大幅度的降低了DSS（决策支持系统）应用的研发成本、开发周期与人力成本。-->
<!--        </div>-->
<!--        <div class="pt-3">-->
<!--          它包括最底层的数据管理平台，可以实现多种数据源的企业级管理、数字化平台，可以高效低成本的处理非结构化数据转结构化过程，并快速构建知识图谱；智能化的平台，可以实现数字化转型中各类智能决策的应用。-->
<!--        </div>-->
<!--      </div>-->
      <v-row style="margin-top: 82px" >
        <v-col :cols="3">
          <div class="d-flex justify-space-between">
            <template>
              <div style="width: 100%;" class="pa-8 rounded-sm im3-card">
                <div class="d-flex justify-center align-center im3-card-title white--text">
                  {{ im3.right[0].title }}
                </div>
                <div style="height: 500px" class="d-flex justify-space-around flex-column align-center mt-5">
                  <template v-for="(im3ItemText, index) in im3.right[0].content">
                    <div :key="im3ItemText" class="d-flex flex-column mt-5">
                      <div
                        class="im3-card-text"
                      >{{ im3ItemText }}
                      </div>
                      <down-two v-if="index !== im3.right[0].content.length - 1" theme="filled" size="24" fill="#2f81f6" :strokeWidth="3" strokeLinejoin="bevel"/>
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </v-col>
        <v-col :cols="6" class="d-flex justify-space-between align-center">
          <div>
            <right-two theme="filled" size="24" fill="#2f81f6" :strokeWidth="3" strokeLinejoin="bevel"/>
          </div>
          <div style="position: relative">
            <div style="position: absolute;top: 40px;left: -40px">方法验证与创新</div>
            <div style="position: absolute;top: 40px;right: -40px">AI辅助融合分析</div>
            <v-img :src="cirCle1"></v-img>
            <div style="width: 100%;text-align: center">AI辅助成果转化</div>
          </div>
          <div>
            <left-two theme="filled" size="24" fill="#2f81f6" :strokeWidth="3" strokeLinejoin="bevel"/>
          </div>
        </v-col>
        <v-col :cols="3">
          <div class="d-flex justify-space-between">
            <template>
              <div style="width: 100%;" class="pa-8 rounded-sm im3-card">
                <div class="d-flex justify-center align-center im3-card-title white--text">
                  {{ im3.right[1].title }}
                </div>
                <div style="height: 500px" class="d-flex justify-space-around flex-column align-center mt-5">
                  <template v-for="(im3ItemText, index) in im3.right[1].content">
                    <div :key="im3ItemText" class="d-flex flex-column mt-5">
                      <div
                        class="im3-card-text"
                      >{{ im3ItemText }}
                      </div>
                      <down-two v-if="index !== im3.right[1].content.length - 1" theme="filled" size="24" fill="#2f81f6" :strokeWidth="3" strokeLinejoin="bevel"/>
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </v-col>
      </v-row>
      <!-- 产品核心功能与整体架构 -->
      <prod-core-card></prod-core-card>
    </dss-card>
<!--   核心技术能力：真实世界知识图谱和大语言模型的融合迭代能力 -->
    <core-technology :wrap-width="wrapWidth"/>
<!--    核心价值-->
    <core-value :wrap-width="wrapWidth"/>
    <!-- 合作案例 -->
<!--    <cooperation-case :wrap-width="wrapWidth"/>-->
    <cooperation-new-case :wrap-width="wrapWidth"/>

    <div style="margin-top: 60px">
      <div class="medi-simp-1 text-center">合作伙伴</div>
      <cooperation
        :cooperationItems="cooperationItems"
        :wrapWidth="wrapWidth"
        @onChange="onChangeCooperation"></cooperation>
    </div>
  </div>
</template>

<script>
// # 首页轮播图
import ImageDss from '../../../assets/pc/index/bannerdss.png'
// import ImageHealth from '../../../assets/pc/index/banner健康.png'
// import ImageKj from '../../../assets/pc/index/banner保险.png'
// import ImageYl from '../../../assets/pc/index/banner医疗.png'
// # 向右的箭头
import imageArrowLeft from '../../../assets/pc/index/dss/箭头左_arrow-left.png'
// # 自定义的组件
import DecisionMaking from './dss/decision-making.vue'
import DssCard from './dss/dss-card.vue'
import CooperationCase from './dss/cooperation-case.vue'
// # 产品核心功能组件
import prodCoreCard from './prodCore/prodCoreCard.vue'
import {DownTwo, RightTwo, LeftTwo} from '@icon-park/vue'
import CirCle1 from '../../../assets/pc/index/smart/circle1.png'
import CoreTechnology from './prodCore/coreTechnology.vue'
import CooperationNewCase from './prodCore/cooperation-new-case.vue'
import Cooperation from '../aboutMe/cooperation.vue'
import CoreValue from './prodCore/core-value.vue'
export default {
  name: 'index',
  components: {
    CoreValue,
    Cooperation,
    CooperationCase,
    DssCard,
    DecisionMaking,
    prodCoreCard,
    DownTwo,
    RightTwo,
    LeftTwo,
    CoreTechnology,
    CooperationNewCase
  },
  props: {
    wrapWidth: {
      type: Number,
      default: 0
    },
    wrapHeight: {
      type: Number,
      default: 0
    }
  },
  computed: {
    headerImgHeight () {
      let width = this.wrapWidth
      if (width <= 1280) {
        return 525
      } else if (width > 1280 && width <= 1536) {
        return 580
      } else {
        return 730
      }
    }
  },
  data () {
    return {
      slidesValue: 0,
      cirCle1: CirCle1,
      slides: [
        {
          id: 1,
          image: ImageDss,
          desc: [
            {
              row: 1,
              content: [
                { strong: true, text: '智能临床科研平台' }
              ]
            },
            {
              row: 2,
              content: [
                { strong: false, text: 'AI辅助科研全流程' }
                // { strong: true, text: '自动化' }
              ]
            },
            {
              row: 3,
              content: [
                { strong: true, text: '更高效、低门槛' }
                // { strong: false, text: '决策触手可及！' }
              ]
            }
          ],
          descSub: '提供智能化科研整体解决方案',
          route: null,
          name: 'dss'
        }
        // {
        //   id: 2,
        //   image: ImageHealth,
        //   route: '/health',
        //   desc: [
        //     {
        //       row: 1,
        //       content: [
        //         { strong: true, text: '数愈健康' }
        //       ]
        //     },
        //     {
        //       row: 2,
        //       content: [
        //         { strong: false, text: '与您共同' },
        //         { strong: true, text: '抵御疾病' }
        //       ]
        //     },
        //     {
        //       row: 3,
        //       content: [
        //         { strong: false, text: '破解' },
        //         { strong: true, text: '胃肠健康' },
        //         { strong: false, text: '的秘密' }
        //       ]
        //     }
        //   ],
        //   descSub: '专注于创新胃肠道健康管理产品设计和营销运营服务',
        //   name: '健康'
        // },
        // {
        //   id: 3,
        //   image: ImageKj,
        //   route: '/technology',
        //   desc: [
        //     {
        //       row: 1,
        //       content: [
        //         { strong: true, text: '数愈科技' }
        //       ]
        //     },
        //     {
        //       row: 2,
        //       content: [
        //         { strong: false, text: '为创新' },
        //         { strong: true, text: '健康险' }
        //       ]
        //     },
        //     {
        //       row: 3,
        //       content: [
        //         { strong: false, text: '提供支撑' },
        //         { strong: true, text: '服务平台' }
        //       ]
        //     }
        //   ],
        //   descSub: '平台包括智能核保、理赔、录入、核赔和理算等全流程数字化健康险业务能力提供基于院外医疗单证图像的精准患者画像',
        //   name: '保险'
        // }
        // {
        //   id: 4,
        //   image: ImageYl,
        //   route: '/medicalcare',
        //   desc: [
        //     {
        //       row: 1,
        //       content: [
        //         { strong: true, text: '数愈医疗' }
        //       ]
        //     },
        //     {
        //       row: 2,
        //       content: [
        //         { strong: false, text: '智能CDSS' },
        //         { strong: true, text: '科研一体化' }
        //       ]
        //     },
        //     {
        //       row: 3,
        //       content: [
        //         { strong: false, text: '解决方案服务商' }
        //       ]
        //     }
        //   ],
        //   descSub: '提供工具平台、数据处理服务、科研服务，加速医疗机构和药械企业数智化升级',
        //   name: '医疗'
        // }
      ],
      imageArrowLeft,
      // # index model 3
      im3: {
        left: [
          { text1: '文献数据', text2: '公开数据' },
          { text1: '非结构化数据', text2: '私有数据' }
        ],
        right: [
          {
            title: '临床科研文献处理模块',
            content: ['AI辅助文件检索', 'AI辅助文献筛选', 'AI辅助文献知识提取', 'AI辅助可研性评估', '分析模型设计和管理']
          },
          {
            title: '临床科研数据中心模块',
            content: ['AI辅助CRF表设计', 'AI辅助数据采集', 'AI辅助数据处理', 'AI辅助数据应用', '研究数据准备和管理']
          }
          // {
          //   title: '智能化',
          //   content: ['输入配置', '规则配置', '输出配置', '应用配置']
          // }
        ]
      },
      cooperationItems: [
        { name: '复旦大学附属华东医院', img: '复旦大学附属华东医院.png' },
        { name: '中山大学附属第一医院', img: '中山大学附属第一医院.png' },
        { name: '青岛大学附属医院', img: '青岛大学附属医院.png' },
        { name: '华西医院', img: '华西医院.png' },
        { name: '江苏省人民医院', img: '江苏省人民医院.png' },
        { name: '中南大学湘雅医院', img: '中南大学湘雅医院.png' },
        { name: '四川省人民医院', img: '四川省人民医院.png' },
        { name: '西安交通大学第一附属医院', img: '西安交通大学第一附属医院.png' },
        { name: '罗氏', img: '罗氏.png' },
        { name: '浙江大学附属第一医院', img: '浙江大学附属第一医院.png' },
        { name: '深圳市人民医院', img: '深圳市人民医院.png' },
        { name: '汇医慧影', img: '汇医慧影.png' },
        { name: '深圳市第三人民医院', img: '深圳市第三人民医院.png' }
      ]
    }
  },
  methods: {
    // Banner
    onclickSlideButton (n) {
      this.slidesValue = n - 1
    },
    onclickSlideItem (item) {
      if (!item.route) {
        if (item.name === 'dss') {
          document.getElementById('position-dss').scrollIntoView({ behavior: 'smooth' })
        }
        return
      }
      this.$emit('goToHeaderTab', {
        route: item.route,
        text: item.text
      })
    },
    onChangeCooperation (item) {
      this.$emit('changeRoute', item, {
        text: '合作机构',
        belongTo: '/aboutMe',
        fromPath: 'medical'
      })
    }
  }
}
</script>

<style scoped>
/* 2023-02-20 */
.banner-content {
  width: 80%;
  margin: auto;
  height: 100%;
  position: relative
}

.banner-description {
  position: absolute;
  top: 40%;
  left: 0;
  transform: translateY(-40%);
}

.banner-description strong {
  font-size: 48px;
}

.banner-description span {
  font-size: 38px;
}

.banner-hr {
  height: 3px;
  width: 72px;
}

.banner-toggle-btn {
  position: absolute;
  bottom: 11%;
  height: 36px;
  left: 1.5rem;
}

/* index-model-3 */
.index-model-3 {
  padding-top: 100px
}

.im3-card {
  width: 30%;
  height: 100%;
  border: 2px dashed #6D8CD6
}

.im3-card-title {
  width: 100%;
  height: 56px;
  font-size: 16px;
  background-color:#517EFF
}

.im3-card-text {
  width: 200px;
  height: 52px;
  background-color: #F7F7F7;
  line-height: 52px;
  text-align: center
}

.im3-footer {
  width: 79.5%;
  margin-left: 19.5%;
  height: 66px;
  line-height: 66px;
  text-align: center;
  margin-top: 53px;
  background-color: #D5DDF0;
  margin-bottom: 108px
}
.medi-simp-1 {
  font-size: 30px;
  font-weight: 500;
  color: #333;
  margin: 0 auto 60px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/pc/home/index.vue